var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4971 4.52094C52.6699 -1.50706 39.3301 -1.50706 28.5029 4.52094L17.4971 10.6483C6.66986 16.6763 0 27.8165 0 39.8725V52.1273C0 64.1833 6.66986 75.3235 17.4971 81.3515L28.5029 87.4789C39.3301 93.5069 52.6699 93.5069 63.4971 87.4789L74.5029 81.3515C85.3301 75.3235 92 64.1833 92 52.1273V39.8725C92 27.8165 85.3301 16.6763 74.5029 10.6483L63.4971 4.52094Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 21C32.1974 21 21 32.1974 21 46C21 59.8027 32.1974 71 46 71C59.8027 71 71 59.8027 71 46C71 32.1974 59.8027 21 46 21ZM44.6973 66.04V50.3587H35.98L48.505 25.9599V41.6413H56.8967L44.6973 66.04Z",
    fill: "#7AC142"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkLogo);
export default __webpack_public_path__ + "static/media/network-logo.3902230517f623aeb682037ff832fe02.svg";
export { ForwardRef as ReactComponent };